import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'shared/shared.module';

import { PromptuaryFillingInstructionsWarningModule } from '../promptuary-instructions-filling-warning/promptuary-filling-instructions-warning.module';
import { StatusIconModule } from '../status-icon/status-icon.module';
import { PromptuaryServiceEvolutionCRMComponent } from './promptuary-service-evolution-crm.component';

@NgModule({
	declarations: [PromptuaryServiceEvolutionCRMComponent],
	imports: [
		CommonModule,
		PromptuaryFillingInstructionsWarningModule,
		TranslateModule,
		SharedModule,
		StatusIconModule,
	],
	exports: [PromptuaryServiceEvolutionCRMComponent],
	providers: [],
})
export class PromptuaryServiceEvolutionCRMModule {}
